module.exports = __webpack_public_path__ + "img/8ead00d4d79ac5e628e348dc0d0bb02.3dfab288.png";